import React from 'react'
import Section from '../../ui/section'
import DemoButton from '../demo_button'
import blobSvg from './blob.svg'
import p1 from './p1.png'
import p2 from './p2.png'
import p3 from './p3.png'
import p4 from './p4.png'

import styles from './cta_section.module.css'

export default (props) => (
  <Section classNames={styles.ctaSection}>
    <div className={styles.ctaBg} style={{
      backgroundImage: `url(${blobSvg})`
    }} />

    <div className={styles.ctaContent}>
      <h5 className={styles.ctaSubtitle}>
        {props.website.footerCtaTitle}
      </h5>
      <div className={styles.ctaTitleWrapper}>
        <h2 className={styles.ctaTitle}>
          {props.website.footerCtaDescription}
        </h2>
      </div>
      <div className={styles.demoButtonContainer}>
        <DemoButton label={props.website.footerCtaButtonLabel} />
      </div>
    </div>

    <img src={p1} className={styles.p1} />
    <img src={p2} className={styles.p2} />
    <img src={p3} className={styles.p3} />
    <img src={p4} className={styles.p4} />

    <div className={styles.c1} />
    <div className={styles.c2} />
    <div className={styles.c3} />
    <div className={styles.c4} />
  </Section>
)
